<template>
    <div class="page-error">
        <ErrorFiveHundredMessage :errors>
            <slot />
        </ErrorFiveHundredMessage>
    </div>
</template>

<script setup lang="ts">
import ErrorFiveHundredMessage from '@/components/ui/error/ErrorFiveHundredMessage.vue'
import type { ErrorCollectionWithTraces } from '@/helpers/errors'

defineProps<{
    errors: ErrorCollectionWithTraces
}>()
</script>

<style lang="scss" scoped>
.page-error {
    width: 100%;
    padding: 1rem;
    background: $red;
    color: $white;
    font-family: $effra-font-stack;
    font-size: 1rem;
    line-height: 1.2em;
    font-weight: 400;
    letter-spacing: 0.025em;
    text-align: center;
}
</style>
